import {
  FiEye,
  FiEyeOff,
  FiSun,
  FiMoon,
  FiRefreshCcw,
  FiList,
} from "react-icons/fi";
import {
  MdKeyboardArrowRight,
  MdClose,
  MdArrowDropDown,
  MdArrowDropUp,
  MdMoreHoriz,
} from "react-icons/md";
import { VscHome } from "react-icons/vsc";
import { BiArrowToTop } from "react-icons/bi";
import {
  RiMenu4Fill,
  RiArrowDropUpLine,
  RiArrowDropDownLine,
} from "react-icons/ri";
import { TbReportSearch } from "react-icons/tb";
import {
  BsWindowDock,
  BsSave,
  BsFiletypePdf,
  BsCalendar3,
  BsArrowBarUp,
  BsArrowBarDown,
  BsImage,
} from "react-icons/bs";
import { CgAttribution } from "react-icons/cg";
import { SlLogout } from "react-icons/sl";
import { IoDocumentTextOutline } from "react-icons/io5";
import { ImPlay2 } from "react-icons/im";
import { RxExit } from "react-icons/rx";
import { BiUser } from "react-icons/bi";
import {
  FaBrush,
  FaFileExcel,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaAngleLeft,
  FaAngleRight,
  FaPlus,
  FaMinus,
} from "react-icons/fa";
import { IoMdGrid } from "react-icons/io";
export const EYEOPENICON = () => {
  return <FiEye />;
};
export const EYECLOSEICON = () => {
  return <FiEyeOff />;
};
export const TOGGLEARROWICON = () => {
  return <MdKeyboardArrowRight />;
};
export const HOMEICON = () => {
  return <VscHome />;
};
export const MODULEICON = () => {
  return <BsWindowDock />;
};
export const INQUIRYICON = () => {
  return <TbReportSearch />;
};
export const ATTRIBUTEICON = () => {
  return <CgAttribution />;
};
export const LOGOUTICON = () => {
  return <SlLogout />;
};
export const SUNICON = () => {
  return <FiSun />;
};
export const MOONICON = () => {
  return <FiMoon />;
};
export const DROPDOWNICON = () => {
  return <RiArrowDropDownLine />;
};
export const DROPUPICON = () => {
  return <RiArrowDropUpLine />;
};
export const DOCUMENTICON = () => {
  return <IoDocumentTextOutline />;
};
export const SAVEICON = () => {
  return <BsSave />;
};
export const EXECUTEICON = () => {
  return <ImPlay2 />;
};
export const PDFICON = () => {
  return <BsFiletypePdf />;
};
export const EXCELICON = () => {
  return <FaFileExcel />;
};
export const RESETICON = () => {
  return <FiRefreshCcw />;
};
export const CLEARICON = () => {
  return <FaBrush />;
};
export const EXITICON = () => {
  return <RxExit />;
};
export const USERICON = () => {
  return <BiUser />;
};
export const MENUICON = () => {
  return <RiMenu4Fill />;
};
export const CLOSEICON = () => {
  return <MdClose />;
};
export const CALENDERICON = () => {
  return <BsCalendar3 />;
};
export const PAGELASTICON = () => {
  return <FaAngleDoubleRight />;
};
export const PAGEFIRSTICON = () => {
  return <FaAngleDoubleLeft />;
};
export const PAGENEXTICON = () => {
  return <FaAngleRight />;
};
export const PAGEPREVIOUSICON = () => {
  return <FaAngleLeft />;
};
export const PAGEPTOPICON = () => {
  return <BiArrowToTop />;
};
export const PAGEBOTTOMICON = () => {
  return <BsArrowBarDown />;
};
export const IMAGEICON = () => {
  return <BsImage />;
};
export const SORTDROPDOWNICON = () => {
  return <MdArrowDropDown />;
};
export const SORTDROPUPICON = () => {
  return <MdArrowDropUp />;
};
export const MOREOPTIONICON = () => {
  return <MdMoreHoriz />;
};
export const LISTVIEWICON = () => {
  return <FiList />;
};
export const GRIDVIEWICON = () => {
  return <IoMdGrid />;
};
export const PLUSICON = () => {
  return <FaPlus />;
};
export const MINUSICON = () => {
  return <FaMinus />;
};
